module.exports = __webpack_public_path__ + "media/tacklebox/assets/images/views/advertisements/amazon-831b45586f8b8f9a3f2c9e300963f0c5.png";